interface Props {
  props: {
    label?: string;
    value?: number;
    total?: number;
  };
}

export function PanelProgressBar({ props }: Props) {
  const total = props?.total ?? 100;
  const value = Math.max(0, Math.min(total, Number(props?.value ?? 0)));
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div style={{ margin: '4px 0' }}>
      {props?.label && (
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            fontSize: 11,
            color: 'var(--text-soft)',
            marginBottom: 4,
          }}
        >
          <span>{props.label}</span>
          <span style={{ color: 'var(--text-mute)', fontVariantNumeric: 'tabular-nums' }}>{pct}%</span>
        </div>
      )}
      <div
        style={{
          height: 6,
          background: 'var(--bg-inset)',
          borderRadius: 3,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: '100%',
            background: 'var(--accent)',
            transition: 'width 160ms ease',
          }}
        />
      </div>
    </div>
  );
}
